import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: LoaderService) {}
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(request?.body?.operationName === 'configuratorFpcs'){
      // download the FPC data in the background.
      return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
        this.loaderService.hideLoader();
      }));
    }

    if(request?.body?.operationName === 'configuratorAllTestCases'){
      // download test cases in the background.
      return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
        this.loaderService.hideLoader();
      }));
    }
    if(request?.body?.operationName === 'configuratorAllTestCasesPagination'){
      // download test cases in the background.
      return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
        this.loaderService.hideLoader();
      }));
    }

    if(request?.body?.operationName === 'configuratorAllTestAnalysis'){
      // download test analysis in the background.
      return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
        this.loaderService.hideLoader();
      }));
    }

    if(request?.body?.operationName === 'configuratorUserFunctions'){
      // download UFs in the background.
      return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
        this.loaderService.hideLoader();
      }));
    }

    if(request?.body?.operationName === 'configuratorTestAnalysisSearchUiTemplate'
        || request?.body?.operationName === 'configuratorTestCaseSearchUiTemplate'
        || request?.body?.operationName === 'configuratorTestSuiteSearchUiTemplate'
        || request?.body?.operationName === 'configuratorTestSpecificationSearchUiTemplate'
        || request?.body?.operationName === 'configuratorSpecificationCoverageSearchUiTemplate'){
      // download search templates in the background.
      return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
        this.loaderService.hideLoader();
      }));
    }

    if(request?.body?.operationName === 'configuratorSearchTestAnalysis'
        || request?.body?.operationName === 'configuratorSearchTestSuite'
        || request?.body?.operationName === 'configuratorSearchTestCase'){
      // inline search from linking modals — handled by table spinner.
      return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
        this.loaderService.hideLoader();
      }));
    }

    this.loaderService.showLoader();
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
          this.loaderService.hideLoader();
      }
      }, (error) => {
          this.loaderService.hideLoader();
      }));
  }
}
